export default __webpack_public_path__ + "media/flags/mw-e92243c6.svg";